import React, { useState } from "react";

const LinesHandler = ({
  lineComponent: LineComponent,
  lineType,
  control,
  errors,
  unregister,
  setValue,
  getValues,
  trigger,
  selectedCourses,
  handleCourseChange,
  selectedAccommodations,
  handleAccommodationChange,
}) => {
  const [lines, setLines] = useState([1]);

  const handleAddLine = () => {
    const newId = lines.length ? Math.max(...lines) + 1 : 1;
    setLines([...lines, newId]);
  };

  const handleRemoveLine = (id) => {
    if (lineType === "accommodation") {
      unregister(`accommodation${id}Type`);
      unregister(`accommodation${id}Beds`);
    } else {
      unregister(`course${id}CourseTitle`);
      unregister(`course${id}Participants`);
      unregister(`course${id}DateStart`);
      unregister(`course${id}DateEnd`);
      unregister(`course${id}TeacherName`);
      unregister(`course${id}TeacherEmail`);
      unregister(`course${id}TeacherCode`);
    }

    const updatedLines = lines.filter((lineId) => lineId !== id);
    setLines(updatedLines);

    //All the below is just to keep number consecutively in data but it was generating some bug in Select value

    // Update form data for the remaining lines
    // updatedLines.forEach((lineId) => {
    //   const nextId = lineId < id ? lineId : lineId - 1;
    //   const lineValueAccommodationType = getValues(
    //     `${lineId}-accommodationType`
    //   );
    //   const lineValueAccommodationBeds = getValues(
    //     `${lineId}-accommodationBeds`
    //   );
    //   unregister(`${lineId}-accommodationType`);
    //   unregister(`${lineId}-accommodationBeds`);
    //   setValue(`${nextId}-accommodationType`, lineValueAccommodationType);
    //   setValue(`${nextId}-accommodationBeds`, lineValueAccommodationBeds);
    // });
    // Recalculate IDs consecutively
    // const recalculatedLines = updatedLines.map((lineId, index) => index + 1);
    // setLines(recalculatedLines);

    //End
  };
  return (
    <div className="mb-1">
      <div>
        {lines.map((id) => (
          <LineComponent
            key={id}
            id={id}
            onRemove={handleRemoveLine}
            control={control}
            errors={errors}
            unregister={unregister}
            setValue={setValue}
            getValues={getValues}
            trigger={trigger}
            selectedCourses={selectedCourses}
            handleCourseChange={handleCourseChange}
            selectedAccommodations={selectedAccommodations}
            handleAccommodationChange={handleAccommodationChange}
          />
        ))}
        <button
          type="button"
          className="add-line-button"
          onClick={handleAddLine}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default LinesHandler;
